import { createApi } from '@reduxjs/toolkit/query/react';

import { toUser } from '@/features/auth/toUser';
import { User } from '@/features/auth/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const authApi = createApi({
  reducerPath: 'authApi',
  // '' keeps the http instance's own baseURL: GET /api/user
  baseQuery: axiosBaseQuery({ baseUrl: '' }),
  endpoints: builder => ({
    getCurrentUser: builder.query<User, void>({
      query: () => ({ url: '/user' }),
      transformResponse: toUser,
    }),
  }),
});

export const { useGetCurrentUserQuery } = authApi;
